import Button from "src/components/general/buttonv3";

const FooterPersonalPrice = () => {
  return (
    <>
      <div className="sm:-mt-10 mt-10 flex w-full items-end justify-center ">
        <div className="flex h-[360px] w-[350px] items-end justify-center rounded-xl bg-linear-to-r from-brand-purple to-brand-blue lg:mt-20 lg:h-[192px] lg:w-[1024px]">
          <div className="mb-[2px] flex h-[356px] w-[346px] flex-col rounded-xl bg-brand-slate bg-clip-border lg:h-[188px] lg:w-[1020px] lg:flex-row lg:items-end">
            <div className="flex h-full w-full items-center justify-center rounded-xl bg-brand-slate">
              <div>
                <div className="flex flex-col items-center">
                  <div className="flex">
                    <p className="text-center font-bold text-4xl lg:text-5xl">
                      Have questions? We&apos;re here to help
                    </p>
                  </div>

                  <div className="mt-8 flex flex-col items-center gap-y-5 lg:flex-row lg:gap-x-5 lg:gap-y-0">
                    <Button
                      isDisabled={false}
                      buttonText="Talk to sales"
                      buttonURL="/contact-expert"
                      color="brandFree"
                      size="md"
                    />
                    <Button
                      isDisabled={false}
                      buttonText="Read our blog"
                      buttonURL="https://redact.dev/blog"
                      color="brandFree"
                      size="md"
                    />
                    <Button
                      isDisabled={false}
                      buttonText="Services"
                      buttonURL="/services"
                      color="brandFree"
                      size="md"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-28" />
    </>
  );
};

export default FooterPersonalPrice;
